<script>
import ClickOutside from "@/directives/click-outside";

export default {
  name: "BattlegroundsDialog",

  directives: {
    ClickOutside,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    showDialog: false,
  }),

  methods: {
    closeDialog() {
      this.showDialog = false;
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="showDialog"
    transition="dialog-transition"
    max-width="1500"
    content-class="elevation-0 history-dialog"
    @keydown.esc="closeDialog()"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="border-doubled gold large mb-3 mb-sm-2 mx-3"
        v-bind="attrs"
        v-on="on"
      >
        {{ title }}
      </v-btn>
    </template>

    <div
      :class="{
        'd-flex justify-center align-center': isMobile,
      }"
      class="modal-container"
    >
      <div
        class="w-full"
        v-click-outside="
          () => {
            closeDialog();
          }
        "
      >
        <div class="title__wrapper" @click="closeDialog()">
          <template v-if="!isMobile">
            <div class="title__container">
              <div class="title">
                <span class="text-capitalize"> {{ title }} </span>
                <div class="title__extra" />
              </div>
            </div>
            <div class="subtitle" />

            <div class="title-line">
              <div class="main-line">
                <div />
                <div />
                <div />
              </div>
              <div class="secondary-line">
                <div />
                <div />
                <div />
              </div>
            </div>
          </template>
          <div
            v-else
            style="border-radius: 10px 10px 0 0"
            class="title__wrapper__mobile d-flex flex-column justify-space-between w-full main--gradient h-full white--text"
          >
            <p
              class="font-size-32 font-weight-superbold text-uppercase text-center py-3 mb-0"
            >
              {{ title }}
            </p>
            <slot name="title-buttons" />
          </div>
        </div>

        <div class="content">
          <v-icon
            v-if="!isMobile"
            color="white"
            size="26"
            style="top: 20px; right: 20px"
            class="position-absolute"
            @click="showDialog = false"
          >
            mdi-close
          </v-icon>
          <slot name="content" />
        </div>
      </div>
      <div class="goldBtn-container">
        <v-btn class="goldBtn double-border" @click="showDialog = false">
          CLOSE
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<style scoped lang="scss">
.main--gradient {
  background: rgb(0, 0, 0);
  background: linear-gradient(
    90deg,
    rgba(88, 60, 113, 1) 0%,
    rgba(37,15,59, 1) 100%,
  );

  &:after {
    content: "";
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 100%;
    height: 12px;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.5), transparent);
    clip-path: polygon(0 0, 100% 0, 0 100%);
  }
}

.modal-container::v-deep {
  transition: 0.2s;
  border-radius: 10px;

  .title__wrapper {
    position: relative;
    z-index: 3;
    height: 100px;

    .title__wrapper__mobile {
      p,
      .v-btn {
        letter-spacing: 1px !important;
        filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.9));
      }
    }

    .title__container {
      position: absolute;
      top: 40px;
      left: 50%;
      transform: translate(-50%, 0px);
      z-index: 2;

      .title {
        width: 480px;
        position: relative;
        text-align: center;
        border-bottom: 50px solid #583c71;
        border-left: 38px solid transparent;
        border-right: 38px solid transparent;

        &::before,
        &::after {
          content: "";
          position: absolute;
          background: #583c71;
        }

        &::before {
          left: -5px;
          top: -10px;
          width: 413px;
          height: 30px;
          border-top-right-radius: 24px;
          border-top-left-radius: 24px;
        }

        &::after {
          left: -41px;
          bottom: -80px;
          width: 486px;
          height: 48px;
          border-radius: 84px 84px 43px 43px;
        }

        span {
          position: absolute;
          left: 0;
          top: 15px;
          width: 100%;
          color: white;
          font-size: 58px;
          font-weight: 800;
          text-shadow: 1px 1px 10px #000000;
          z-index: 2;
        }
      }
    }

    .subtitle {
      position: absolute;
      left: 50%;
      top: 108px;
      transform: translate(-50%, 0);
      width: 400px;
      text-align: center;
      height: 30px;
      background: rgb(0, 0, 0);
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(88, 60, 113, 1) 100%
      );
      border-radius: 36px;
      z-index: -1;
    }

    .title-line {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      overflow: hidden;

      .main-line,
      .secondary-line {
        height: 40px;
        display: grid;
        grid-template-columns: 40px auto 40px;

        div {
          &:first-child {
            position: relative;
            top: 9px;
            border-top: 24px solid rgb(133, 118, 177);
            border-left: 10px solid transparent;
            margin-left: 4px;

            &:before {
              content: "";
              position: absolute;
              left: -11px;
              top: -33px;
              background: #8576b1;
              width: 40px;
              height: 20px;
              border-radius: 19px 0 0 67px;
            }

            &:after {
              content: "";
              position: absolute;
              left: -1px;
              bottom: 7px;
              background: #8576b1;
              width: 31px;
              height: 20px;
              border-radius: 7px 0 0 24px;
            }
          }

          &:nth-child(2) {
            background: rgb(133, 118, 177);
            background: linear-gradient(
              90deg,
              rgba(133, 118, 177, 1) 0%,
              rgba(90, 61, 116, 1) 20%,
              rgba(90, 61, 116, 1) 80%,
              rgba(133, 118, 177, 1) 100%
            );
          }

          &:last-child {
            position: relative;
            top: 9px;
            border-top: 24px solid rgb(133, 118, 177);
            border-right: 10px solid transparent;
            margin-right: 4px;

            &:before {
              content: "";
              position: absolute;
              right: -11px;
              top: -33px;
              background: #8576b1;
              width: 40px;
              height: 20px;
              border-radius: 0 19px 67px 0;
            }

            &:after {
              content: "";
              position: absolute;
              right: -1px;
              bottom: 7px;
              background: #8576b1;
              width: 31px;
              height: 20px;
              border-radius: 0 7px 24px 0;
            }
          }
        }
      }

      .secondary-line {
        position: absolute;
        left: 20px;
        bottom: 0;
        display: grid;
        grid-template-columns: 20px auto 20px !important;
        width: calc(100% - 40px);
        height: 28px;

        div {
          &:first-child {
            position: relative;
            top: 9px;
            right: -6px;
            border-top: 21px solid rgba(88, 60, 113);
            border-left: 10px solid transparent;
            margin-left: 0;

            &:before {
              content: "";
              position: absolute;
              left: -10px;
              top: -30px;
              background: #583c71;
              width: 20px;
              height: 20px;
              border-radius: 11px 0 0 24px;
            }

            &:after {
              content: none !important;
            }
          }

          &:nth-child(2) {
            background: rgb(88, 60, 113);
            background: linear-gradient(
              90deg,
              rgba(88, 60, 113, 1) 0%,
              rgba(46, 32, 58, 1) 36%,
              rgba(46, 32, 58, 1) 64%,
              rgba(88, 60, 113, 1) 100%
            );
          }

          &:last-child {
            position: relative;
            top: 9px;
            left: -6px;
            border-top: 21px solid rgba(88, 60, 113);
            border-right: 10px solid transparent;
            margin-right: 0;

            &:before {
              content: "";
              position: absolute;
              right: -10px;
              top: -30px;
              background: #583c71;
              width: 20px;
              height: 20px;
              border-radius: 0 11px 24px 0;
            }

            &:after {
              content: none !important;
            }
          }
        }

        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: -10px;
          width: 100%;
          height: 20px;
          background-image: url("/images/Highlight.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .content {
    position: relative;
    background: rgb(49, 39, 58);
    background: linear-gradient(
      325deg,
      rgba(49, 39, 58, 1) 0%,
      rgb(109, 75, 139) 100%
    );
    padding: 70px 75px 20px 75px;
    min-height: 400px;
    margin: 0 46px;
    border-radius: 0 0 20px 20px;
    z-index: 1;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("/images/backgrounds/backgroundParticles.png");
      background-size: cover;
      background-position: center center;
      border-radius: 0 0 20px 20px;
      z-index: -1;
    }

    .content-tabs {
      .rooms-button {
        color: white;
        font-size: 32px;
        font-weight: 900;
        border-radius: 10px !important;
      }
    }
  }
}

.goldBtn-container {
  display: none;
  position: absolute;
  bottom: 100px;
  left: 50%;
  width: 50%;
  transform: translate(-50%, 0);
  filter: drop-shadow(0 0 #121212);
  z-index: 3;

  .goldBtn {
    width: 100%;
    min-width: initial !important;
  }

  &::after {
    content: "";
    position: absolute;
    left: -10px;
    bottom: -10px;
    width: calc(100% + 20px);
    height: calc(100% + 20px);
    background: #121212;
    border-radius: 32px;
    z-index: -1;
  }
}

// Large LG

@media screen and (max-width: 992px) {
  .modal-container {
    .content {
      padding: 70px 40px 20px;
    }
  }
}

// MD

@media screen and (max-width: 768px) {
  .modal-container {
    //margin: 0 40px 185px 40px;
    padding: 40px 40px 185px 40px;

    .title__wrapper {
      height: initial;
    }

    .content {
      padding: 0 12px;
      margin: 0;
      min-height: initial !important;
    }
  }
  .goldBtn-container {
    display: block !important;
  }
}

// ~SM

@media screen and (max-width: 600px) {
  .modal-container {
    //margin: 0 15px 185px 15px;
    padding: 15px 15px 165px;

    .content {
      padding: 0 4px 0 0;
      margin: 0;
    }
  }
}
</style>
